import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  addButtonLabel: {
    id: 'contactPersonManager.button.add.label',
    description: 'Label for contact person manager add button',
    defaultMessage: 'Add new',
  },
  editButtonLabel: {
    id: 'contactPersonManager.button.edit.label',
    description: 'Label for contact person manager edit button',
    defaultMessage: 'Edit info',
  },
  fetchingInfo: {
    id: 'contactPersonManager.info.fetching',
    description: 'Info for fetching contact persons',
    defaultMessage: 'Fetching company\'s contact persons.',
  },
  notFoundInfo: {
    id: 'contactPersonManager.info.companyContactPersonsNotFound',
    description: 'Info for company\'s contact persons not found',
    defaultMessage: 'Company does not have any added contact persons yet.',
  }
});
